import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

import { RadioButtonModule } from '@syncfusion/ej2-angular-buttons';
import { NumericTextBoxModule, NumericTextBoxAllModule, MaskedTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { GridModule, ColumnChooserService, PageService, SortService, FilterService, ResizeService } from '@syncfusion/ej2-angular-grids';
import { DropDownListAllModule } from '@syncfusion/ej2-angular-dropdowns';


import { DropdownComponent } from '../../dropdown/dropdown.component';
import { Vieweligibility271Module } from '../vieweligibility271/vieweligibility271.module';
import { Eligibility270Component } from './eligibility270.component';
import { Eligibility270RoutingModule } from './eligibility270-routing.module';
import { Get271Fileservice } from 'src/app/service/eligibility271.service';
import { PDFExportModule } from '@progress/kendo-angular-pdf-export';
import { PdfViewerModule } from 'ng2-pdf-viewer';
// import { Get271Fileservice } from '../../service/get271file.service';

@NgModule({
  declarations: [
    Eligibility270Component
  ],
  imports: [
    CommonModule,
    Eligibility270RoutingModule,
    RadioButtonModule,
    NumericTextBoxModule,
    NumericTextBoxAllModule,
    FormsModule,
    ReactiveFormsModule,
    GridModule,
    DropDownListAllModule,
    MaskedTextBoxModule,
    NgSelectModule,
    PDFExportModule,
    PdfViewerModule,
    DropdownComponent,
    Vieweligibility271Module,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    ColumnChooserService,
    PageService,
    SortService,
    FilterService,
    ResizeService,
    Get271Fileservice
  ],
})
export class Eligibility270Module { }
